import { Link } from 'react-router-dom';
import { MessageCircle, Mail, MapPin, ShieldCheck } from 'lucide-react';
import { NAV_LINKS, site, waUrl, DEFAULT_WA_MESSAGE, normsMarquee } from '../data/site';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative overflow-hidden bg-navy-deep text-white">
      <div className="absolute inset-0 bg-blueprint" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <img src={site.logo} alt="Grupo Majo" className="w-56 rounded-lg bg-white p-2" />
            <p className="mt-6 max-w-sm font-display text-lg font-semibold leading-snug text-gold-light">
              “{site.motto}”
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/60">
              {site.tagline}. Engenharia com responsabilidade técnica, conformidade normativa e atendimento em todo o Brasil.
            </p>
            <a
              href={waUrl(DEFAULT_WA_MESSAGE)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="btn-gold mt-8"
            >
              <MessageCircle size={16} /> Falar com o Engenheiro
            </a>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-display text-xs font-bold uppercase tracking-[0.25em] text-gold">Navegação</h3>
            <ul className="mt-5 space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    data-testid={`footer-link-${l.id}`}
                    className="text-sm text-white/65 transition-colors hover:text-gold-light"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h3 className="font-display text-xs font-bold uppercase tracking-[0.25em] text-gold">Contato Institucional</h3>
            <ul className="mt-5 space-y-4 text-sm text-white/65">
              <li className="flex items-start gap-3">
                <MessageCircle size={16} className="mt-0.5 shrink-0 text-gold" />
                <a href={waUrl(DEFAULT_WA_MESSAGE)} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-gold-light">
                  {site.contact.phoneDisplay}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-0.5 shrink-0 text-gold" />
                <a href={`mailto:${site.contact.email}`} data-testid="footer-email-link" className="transition-colors hover:text-gold-light">
                  {site.contact.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 shrink-0 text-gold" />
                {site.contact.coverage}
              </li>
            </ul>
            <div className="mt-6 rounded-xl border border-white/10 bg-white/5 p-4 text-xs leading-relaxed text-white/60">
              <p className="flex items-center gap-2 font-display font-bold uppercase tracking-wider text-white/80">
                <ShieldCheck size={14} className="text-gold" /> Responsabilidade Técnica
              </p>
              <p className="mt-2">{site.contact.technicalResponsible} — CREA {site.contact.crea}</p>
              <p className="mt-1">Majo Processos e Intermediações LTDA · CNPJ {site.contact.cnpj}</p>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-7 text-[11px] uppercase tracking-wider text-white/40 md:flex-row md:items-center md:justify-between">
          <p>© {year} Grupo Majo — Engenharia, Processos e Intermediações</p>
          <p className="max-w-xl md:text-right">NBR 5410 · NBR 5674 · NBR 13752 · NBR 16280 · NBR 16747 · NR-10 · NR-18 · NR-35</p>
        </div>
      </div>
    </footer>
  );
}
